"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ shape, palette, spacing }) => ({
    rootContainer: (props) => {
        var _a, _b;
        return ({
            borderRadius: shape.borderRadius * 2,
            border: ((_a = props === null || props === void 0 ? void 0 : props.account) === null || _a === void 0 ? void 0 : _a.isClosed) ? `1px solid ${palette.text.secondary}` : 'none',
            background: ((_b = props === null || props === void 0 ? void 0 : props.account) === null || _b === void 0 ? void 0 : _b.isClosed) ? palette.text.strong : palette.text.secondary,
            margin: `${spacing(1)} 0px`,
            paddingLeft: spacing(2),
            paddingRight: spacing(3),
        });
    },
    listItemText: {
        paddingLeft: 0,
    },
    dialogContent: {
        minWidth: 500,
        display: 'flex',
    },
    primaryItem: {
        display: 'flex',
    },
    statusContainer: {
        borderRadius: shape.borderRadius,
        flex: '0 0 auto',
        margin: 'auto 5px',
        height: 'inherit',
    },
    statusRoot: {
        borderRadius: shape.borderRadius,
        marginTop: 1,
        boxSizing: 'border-box',
        padding: `${spacing(0.25)} ${spacing(1)}`,
        color: palette.text.primary,
    },
    statusClose: {
        backgroundColor: palette.action.disabled,
    },
    statusError: {
        backgroundColor: palette.status.surfaceStrong,
    },
    ignoredAccountIcon: {
        marginLeft: 10,
    },
    txnsTransfersStatusContainer: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    greenCheck: {
        color: palette.success.dark,
    },
});
exports.default = styles;
